import React from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { checkValid, setValueForm, updateValidate } from '../../../../../helpers/form/FormHelper'
import { formDataProductIsField, formDataProductRequiredField } from '../../../../../helpers/form/FormData'
import TextFieldMain from '../../../../form/fields/TextFieldMain'
import ErrorMessage from '../../../../UI/messages/ErrorMessage'
import MyButton from '../../../../UI/form/MyButton'
import { responseError } from '../../../../../helpers/response/ResponseHelper'
import { editWriteOffActItem } from '../../../../../store/writeOffSlice'
import { editWriteOffActItemNomenclatureNumberAPI } from '../../../../../api/writeOff/writeOffActItemAPI'

const ChangeNomenclatureNumberForm = ({ writeOffActItemBd, setOpen }) => {

    const dispatch = useDispatch()

    const [data, setData] = useState(
        writeOffActItemBd ? 
            {
                nomenclatureNumber: writeOffActItemBd.nomenclatureNumber,
            } 
        : {}
    ) // Дані з форми

    // console.log('data', data)
        
    const [valid, setValid] = useState({}) // Валідація кожного поля
    const [loading, setLoading] = useState(false)

    const [isValidForm, setIsValidForm] = useState(false) // Загальна валідація форми
    const [result, setResult] = useState('')
    const [error, setError] = useState('')

    useEffect(() => {
        checkValid(valid, setIsValidForm)
    }, [valid])

    const save = (e) => {
        e.preventDefault()
        const dataForBd = getDataForBd()

        setError('')
        setLoading(true)

        editWriteOffActItemNomenclatureNumberAPI(dataForBd).then(data => {
            if (data) {
                dispatch(editWriteOffActItem(data))
            }

            setOpen(false)
            setLoading(false)
        }).catch(e => {
            setError(responseError(e))
            setLoading(false)
        })
    }

    const getDataForBd = () => {
        const dataForBd = {
            id: writeOffActItemBd.id,
            nomenclatureNumber: data.nomenclatureNumber,
        }

        return dataForBd
    }

  return (
    <div className='myFormSimple'>
        {
			formDataProductIsField('nomenclatureNumber', 'writeOffActItem') ?
				<TextFieldMain
					required={formDataProductRequiredField('nomenclatureNumber', 'writeOffActItem')}
					setValidate={e => updateValidate(setValid, 'nomenclatureNumber', e)}
					setValueForm={e => setValueForm(setData, 'nomenclatureNumber', e)}
					forciblyValue={data && data.nomenclatureNumber ? data.nomenclatureNumber : ''}
                    label='Номенклатурний номер'
                    placeholder='Введіть номер'
				/>
			: ''
        }

        <ErrorMessage
            error={error}
        />

        <MyButton
            size='md'
            onClick={save}
            disabled={!isValidForm || loading ? true : false}
        >
            Зберегти
        </MyButton>
    </div>
  )
}

export default ChangeNomenclatureNumberForm